import { json } from "react-router-dom";

const CryptoJS = require("crypto-js");

const secretKey = "datasoftNicktryingCode";

export function encodeAndStoreData(key, data) {
  try {
    const jsonData = JSON.stringify(data);

    const encryptedData = CryptoJS.AES.encrypt(jsonData, secretKey).toString();

    localStorage.setItem(key, encryptedData);
  } catch (error) {
    console.error("Error encrypting and storing data:", error);
  }
}

export function getdataAndDecodeStoreData(key) {
  try {
    const encryptedData = localStorage.getItem(key);

    if (encryptedData === null) {
      // console.log("Data does not exist in localStorage.");
      return;
    }
    const decryptedBytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
    const decryptedData = JSON.parse(
      decryptedBytes.toString(CryptoJS.enc.Utf8)
    );
    return decryptedData;
  } catch (error) {
    console.error("Error retrieving and decrypting data:", error);
  }
}

export function encodeDataforkey(data) {
  try {
    const jsondata = JSON.stringify(data);
    const encryptedData = CryptoJS.AES.encrypt(jsondata, secretKey).toString();
    return encryptedData;
  } catch (error) {
    console.error("Error encrypting and storing data", error);
  }
}

export function decodeDataforkey(data) {
  try {
    const decryptedBytes = CryptoJS.AES.decrypt(data, secretKey);
    const decryptedData = JSON.parse(
      decryptedBytes.toString(CryptoJS.enc.Utf8)
    );
    return decryptedData;
  } catch (error) {
    console.error("Error decodeing data !!!", error);
  }
}
